import enquire from 'enquire.js'

import Component from '../core/Component'
import { CMS, queries } from '../core/config'
import EventBus from '../core/EventBus'
import Scroll, { disableScroll, enableScroll } from '../services/Scroll'
import support from '../utils/BrowserSupport'
import { queryAll } from '../utils/dom'

export const STATES = {
    VISIBLE: 'is-visible',
    ACTIVE: 'is-active',
    PINNED: 'is-pinned',
    DARK: 'is-onDark',
    CURRENT: 'is-current'

}
export default class Nav extends Component {
    constructor(element) {
        super(element)
        this.ref = {
            content: null,
            contact: null,
            list: null,
            links: [],
            hover: null,
        }

        this.isOpen = false
        this.darkSectionsQuery = ['.SectionSlideshow']

        this.state = {
            darkSections: [],
            currentSection: "intro",
        }

        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.handleSection(entry.target.id);
                    }
                });
            },
            {
                rootMargin: '-30% 0% -30% 0%',
            }
        )

        this.enquireHandler = {
            match: this._match.bind(this),
            unmatch: this._unmatch.bind(this)
        }
    }

    prepare() {
        if  (CMS) {
            return
        }

        this.element.addEventListener(support.transitionEnd, () => {
            if (!this.is(STATES.ACTIVE)) {
                this.element.classList.remove(STATES.VISIBLE)
            }
        })

        this.links = this.ref.links.reduce((acc, element) => {
            const key = element.href.split('#')[1]
            acc[key] = element
            return acc
        }, {})

        this.sections = this.ref.links.map(link => {
            const targetId = link.getAttribute('href')?.replace('#', '');
            return document.getElementById(targetId);
        }).filter(el => el !== null)

        this.sections.forEach(section => this.observer.observe(section))

        this.element.addEventListener('click', this.handleClick.bind(this))
        Scroll.on('scroll', this.handleScroll)
        Scroll.on('resize', this.handleResize)

        this.resize()

        enquire.register(queries.xxlargeUp, this.enquireHandler)
    }

    destroy() {
        this.close()

        if (this.observer) {
            this.observer.disconnect()
            this.observer = null
        }

        document.removeEventListener('keydown', this.handleKeydown)
        Scroll.off('scroll', this.handleScroll)
        Scroll.off('resize', this.handleResize)
        enquire.unregister(queries.xxlargeUp, this.enquireHandler)
    }

    handleClick(event) {
        if (event.target.closest('a')) {
            this.close(event)
        }
    }

    handleKeydown = event => {
        if (event.key === 'Escape') {
            this.close()
        }
    }

    toggle() {
        if (this.is(STATES.ACTIVE)) {
            this.close()
        } else {
            this.open()
        }
    }

    close() {
        if (!this.is(STATES.ACTIVE)) {
            return
        }
        this.isOpen = false
        enableScroll()
        this.element.classList.remove(STATES.ACTIVE)
        document.removeEventListener('keydown', this.handleKeydown)
        EventBus.emit('nav:close')
    }

    open() {
        disableScroll()
        this.isOpen = true
        this.element.classList.add(STATES.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)
        document.addEventListener('keydown', this.handleKeydown)
        EventBus.emit('nav:open')
    }

    handleSection = (id) => {
        this.state.currentSection = id
        this.setCurrentSection(id)
    }

    handleScroll = ({offset}) => {
        if (this.isOpen) {
            return
        }

        if (offset.y > 800) {
            this.ref.contact.classList.add(STATES.PINNED)
        }

        if (offset.y < 800) {
            this.ref.contact.classList.remove(STATES.PINNED)
        }

        if (!this.state.darkSections.length) {
            this.resize()
            return
        }

        const isOnDark = !!this.state.darkSections.find(section => offset.y >= section.documentTop && offset.y <= section.documentBottom)

        this.element.classList.toggle(STATES.DARK, isOnDark)
    }

    handleResize = () => {
        if (this.isOpen) {
            return
        }

        this.resize()
    }

    resize() {
        const els = queryAll(...this.darkSectionsQuery)
        const scrollY = Scroll.getScroll().y

        const sections = els.map(el => {
            const rect = el.getBoundingClientRect()

            return {
                documentTop: scrollY + rect.top - 30,
                documentBottom: scrollY + rect.top + rect.height - 30
            }
        })

        this.state.darkSections = sections
    }

    setCurrentSection() {
        const sectionId = this.state.currentSection
        if (!this.links[sectionId]) return

        const box = this.links[sectionId].getBoundingClientRect()
        const elementBox = this.ref.list.getBoundingClientRect()

        Object.entries(this.links).forEach(([key, link]) => {
            const id = this.state.currentSection
            link.classList.toggle(STATES.CURRENT, key === id)
        })

        const elementShift = box.left - elementBox.left

        this.ref.hover.style.width = `${box.width}px`
        this.ref.hover.style.transform = `translateX(${elementShift}px)`
    }

    _match() {
        this.close()

        if (!this.sections || this.sections.length === 0) return
        this.sections.forEach(section => this.observer.observe(section))
    }

    _unmatch() {
        if (this.observer) {
            this.sections.forEach(section => this.observer.unobserve(section))
            this.observer.disconnect()
        }

        this.ref.hover.removeAttribute('style')
    }

}
